import { useNavigate } from "react-router-dom";
import "./product-box-2.styles.css";

const ProductBox2 = ({ cat }) => {
  const { id, title, price, img, discountprice, colors } = cat;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product-page/${id}`);
  };

  const formatPrice = (price) => {
    return Number(price).toLocaleString("fa-IR");
  };

  // بررسی وضعیت اتمام موجودی
  const isSoldOut =
    colors &&
    colors.length > 0 &&
    colors.every((color) => {
      const count = parseInt(color.count || "0", 10);
      const soldCount = parseInt(color.sold_count || "0", 10);
      return count === 0 || soldCount >= count; // بررسی دو شرط برای اتمام موجودی
    });

  return (
    <div className="product-box-2" onClick={handleClick}>
      {isSoldOut && (
        <p className="sold-out-text sold-out-text-2">اتمام موجودی</p>
      )}
      <div className="product-img-wrapper-2">
        <img src={img} alt={title} className="product-img-2" />
      </div>
      <div className="product-info">
        <div className="product-info-top-wrapper">
          <h3 className="product-box-info-title">{title}</h3>
          <div className="product-info-price-and-text">
            {discountprice ? (
              <>
                <p className="product-box-info-text invalid-price">
                  {formatPrice(price)} ریال
                </p>
                <p className="product-box-info-text">
                  {formatPrice(discountprice)} ریال
                </p>
              </>
            ) : (
              <p className="product-box-info-text">{formatPrice(price)} ریال</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductBox2;
